import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "es", "de", "nl", "pap"],
  defaultLocale: "en",
});

export type Locale = (typeof routing.locales)[number];
